import React, { useEffect, useState } from "react";
import "tailwindcss/tailwind.css";
import cross from "../../images/icons/close-button-icon.svg";

const RewardDetailDrawer = ({
  setIsDrawerOpen,
  children,
  isMembershipDetail,
}) => {
  const [isNotVisible, setIsNotVisible] = useState(false);

  useEffect(() => {
    let timer;
    if (isNotVisible) {
      // Delay hiding the component until after the exit animation
      timer = setTimeout(() => setIsDrawerOpen(false), 300);
    }
    return () => clearTimeout(timer);
  }, [isNotVisible]);

  return (
    <>
      <>
        <div
          className="tw-w-screen tw-h-full md:tw-h-screen tw-fixed tw-inset-x-auto tw-top-0 tw-bg-black tw-opacity-[0.6] tw-z-[999]"
          onClick={() => setIsNotVisible(true)}></div>
        <div
          className={`tw-flex tw-flex-col tw-bg-white tw-fixed tw-bottom-0 md:tw-m-auto tw-w-screen tw-z-[9999] tw-gap-4 tw-px-4 tw-pt-4 md:tw-pt-6 tw-pb-[60px] md:tw-pb-10 md:tw-px-10 tw-rounded-tl-2xl tw-rounded-tr-2xl md:tw-rounded
    ${
      isNotVisible
        ? "tw-animate-slideOutToBottom md:tw-animate-none"
        : "tw-animate-slideInFromBottom md:tw-animate-none"
    }
    ${
      isMembershipDetail
        ? "tw-h-[80%] tw-overflow-auto md:tw-w-[640px] md:tw-top-8"
        : "tw-overflow-hidden md:tw-w-[480px] md:tw-bottom-auto md:tw-top-76"
    }`}
          style={{ overflowY: "auto" }}>
          <img
            src={cross}
            height={16}
            width={16}
            style={{ alignSelf: "end", cursor: "pointer" }}
            onClick={() => setIsNotVisible(true)}></img>

          {children}
        </div>
      </>
    </>
  );
};

export default RewardDetailDrawer;
